import BillingViewer from './views/BillingViewer';
export default {
  install(molten) {
    molten.addPlugin('GroupDataViewer', {
      id: 'recovr.group.CustomBillingViewer',
      type: 'billing',
      name: 'Custom Billing Viewer',
      icon: 'fa fa-map fa-fw',
      location: 'main',
      handles: () => true,
      component: BillingViewer
    });
  }
};